import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import Routes from "./router";
import "./index.css";
import "./App.css";
// import moment from "moment";
// import "moment/locale/pt";
import locale from "antd/lib/locale/pt_PT";
import { ConfigProvider } from "antd";

const el = document.getElementById("plataforma");
el.innerHTML = "<p>Div plataforma editada</p>";
console.log(el);

ReactDOM.render(
  // <React.StrictMode>
  <ConfigProvider locale={locale}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </ConfigProvider>,
  // </React.StrictMode>
  document.getElementById("plataforma")
);
